import axios from "axios";
import { authHeaderJson } from "../auth-header.service";
import { isNull } from "lodash-es";
import { isNullUndefinedOrEmpty } from "../../common/Helpers";

const getPrivilegeRoles = () => {
    return axios.get(`/api/Privilege/privilegeroles`, { headers: authHeaderJson() } );
};

const getPrivilegeRolesElements = (elementId) => {
    return axios.get(`/api/Privilege/privilegeroleselement/${elementId}`, { headers: authHeaderJson() } );
};

const getPrivilegeActions = () => {
    return axios.get(`/api/Privilege/privilegeactions`, { headers: authHeaderJson() } );
};

const getPrivilegeMatrix = () => {
    return axios.get(`/api/Privilege/privilematrix`, { headers: authHeaderJson() } );
};

const getPrivilegeElement = (elementId) => {
    return axios.get(`/api/Privilege/privilegeelement/${elementId}`, { headers: authHeaderJson() } );
}

const getPrivilegePartys = (elementId) => {
    return axios.get(`/api/Privilege/privilegepartyselement/${elementId}`, { headers: authHeaderJson() } );
}

const getPrivilegePartyMembers = (elementId) => {
    return axios.get(`/api/Privilege/privilegepartymemberselement/${elementId}`, { headers: authHeaderJson() } );
}

const addPrivilegeRole = (privilegeRole) => {
    return axios({ method: 'post', url: `/api/Privilege/privilegerole`, headers: authHeaderJson(), data : JSON.stringify(privilegeRole) })
};

const addPrivilegeAction = (privilegeAction) => {
    return axios({ method: 'post', url: `/api/Privilege/privilegeaction`, headers: authHeaderJson(), data : JSON.stringify(privilegeAction) })
};

const addPrivilegeApp = (privilegeApp) => {
    return axios({ method: 'post', url: `/api/Privilege/privilegeapp`, headers: authHeaderJson(), data : JSON.stringify(privilegeApp) })
};

const addPrivilegeParty = (privilegeElementParty) => {
    return axios({ method: 'post', url: `/api/Privilege/privilegeparty`, headers: authHeaderJson(), data : JSON.stringify(privilegeElementParty) })
};

const addPrivilegePartyMember = (privilegeElementPartyMember) => {
    return axios({ method: 'post', url: `/api/Privilege/privilegepartymember`, headers: authHeaderJson(), data : JSON.stringify(privilegeElementPartyMember) })
};

const updatePrivilegeRole = (id, privilegeRole) => {
    return axios.put(`/api/Privilege/privilegerole/${id}`, privilegeRole, { headers: authHeaderJson() });
};

const updatePrivilegeAction = (id, privilegeAction) => {
    return axios.put(`/api/Privilege/privilegeaction/${id}`, privilegeAction, { headers: authHeaderJson() });
};

const updatePrivilegeApp = (id, privilegeApp) => {
    return axios.put(`/api/Privilege/privilegeapp/${id}`, privilegeApp, { headers: authHeaderJson() });
};

const updatePrivilegeParty = (id, privilegeElementParty) => {
    return axios.put(`/api/Privilege/privilegeparty/${id}`, privilegeElementParty, { headers: authHeaderJson() });
};

const updatePrivilegePartyMember = (id, privilegeElementPartyMember) => {
    return axios.put(`/api/Privilege/privilegemember/${id}`, privilegeElementPartyMember, { headers: authHeaderJson() });
};

const deletePrivilegePartyMember = (id) => {
    return axios.delete(`/api/Privilege/privilegepartymember/${id}`, { headers: authHeaderJson() });
};

const addListPrivilegePartyMember = (elementId, privilegeElementPartyMemberList) => {
    return axios({ method: 'post', url: `/api/Privilege/privilegepartymember/${elementId}/list`, headers: authHeaderJson(), data : JSON.stringify(privilegeElementPartyMemberList) })
};

const addListPrivilegeMatrix = (privilegeMatrixList) => {
    return axios({ method: 'post', url: `/api/Privilege/privilegematrix/list`, headers: authHeaderJson(), data : JSON.stringify(privilegeMatrixList) })
};

const getPrivilegeMemberRelationshipProps = (tipoBoardId, boardId, elementId, username) => {
    //[##PATH ROUTE##]
    let qs_username = username !== null && username !== 0 ? `?username=${username}` : '';

    return axios.get(`/api/Privilege/usernameProps/${tipoBoardId}/${isNullUndefinedOrEmpty(boardId) ? 0 : boardId}/${isNullUndefinedOrEmpty(elementId) ? 0 : elementId}${qs_username}`, { headers: authHeaderJson() } );
};

const getBookMemberRelationshipProps = (bookId, username) => {
    let qs_username = username !== null && username !== 0 ? `?username=${username}` : '';
    return axios.get(`/api/Privilege/usernameProps/book/${bookId}${qs_username}`, { headers: authHeaderJson() } );
};

const getListPrivilegeBook = () => {
    return axios.get(`/api/Privilege/privilegeroles/book`, { headers: authHeaderJson() } );
};

const getReportClientLogo = () => {
    return axios.get(`/api/env/imageClientLogo`, { headers: authHeaderJson() } );
};


export {
    getPrivilegeRoles,
    getPrivilegeRolesElements,
    getPrivilegeActions,
    getPrivilegeMatrix,
    getPrivilegeElement,
    getPrivilegePartys,
    getPrivilegePartyMembers,
    addPrivilegeRole,
    addPrivilegeAction,
    addPrivilegeApp,
    addPrivilegeParty,
    addPrivilegePartyMember,
    updatePrivilegeRole,
    updatePrivilegeAction,
    updatePrivilegeApp,
    updatePrivilegeParty,
    updatePrivilegePartyMember,
    deletePrivilegePartyMember,
    addListPrivilegePartyMember,
    addListPrivilegeMatrix,
    getPrivilegeMemberRelationshipProps,
    getBookMemberRelationshipProps,
    getListPrivilegeBook,
    getReportClientLogo
}